export default __webpack_public_path__ + "static/media/minusIcon.ddfc0dc4.svg";